<template>
    <modal
      modal-type="bottom-sheet"
      modal-id="details"
      v-bind:modal-visible="detailsViewState">

      <template slot="toolbar-title">
        Map Feature Details
      </template>

      <template slot="body">
          <div
          id="rg-details-body"
          ref="detailsBody">

          <div class="rg-container ">
            <div class="rg-layout"
              v-for="tile in tilesArray"
              :key="tile.key"
              row>
                <div class="rg-card">
                  <div class="flex row xs12">
                    <div class="rg-card-title primary-title">
                      <div class="headline">{{ tile.headline }}</div>
                      <div class="note" v-html="tile.note"></div>
                    </div>
                  </div>
                  <div class="rg-layout details-layout">
                    <div class="rg-card-text">
                      <div
                        class="rg-details-list-row"
                        v-for="field in tile.displayFields"
                        :key="tile.key + field.fieldName">
                        <div class="rg-field-name">{{field.fieldName}}</div>
                        <div class="rg-field-value" v-html="field.fieldValue"></div>
                      </div>
                      <div
                        class="rg-html-tile"
                        v-if="tile.html"
                        v-html="tile.html">
                      </div>
                    </div>
                    <div class="responsive-image-container"
                      v-if="tile.img || tile.html">
                      <!-- TODO: Image Loading Handler -->
                      <img
                        v-if="tile.img"
                        class="responsive-image"
                        :src="getImageUrl(tile)"
                        @error="onImageError(tile)"
                        />
                      <!-- <v-img
                        :src="getImageUrl(tile)"
                        @error="onImageError(tile)">
                        <div class="rg-layout imageError"
                          slot="placeholder">
                          <div v-if="!tile.imgLoadError">
                            <img src="static/loader-icon.svg"/>
                          </div>
                          <div
                            v-else
                            class="error--text">Image Unavailable</div>
                        </div>
                      </v-img> -->
                    </div>
                  </div>
                  <hr class="rg-divider" />
                  <div
                    v-if="tile.directions || tile.link"
                    class="rg-card-actions">
                    Actions
                    <div class="rg-spacer"></div>
                      <!-- v-ripple -->
                    <a class="rg-btn"
                      v-if="tile.directions"
                      :href="tile.directions"
                      target="_blank">
                      <i aria-hidden="true" class="rg-icon material-icons">directions</i>
                    </a>
                    <!-- v-ripple -->
                    <a class="rg-btn"
                      v-if="tile.link"
                      :href="tile.link"
                      target="_blank">
                      <i aria-hidden="true" class="rg-icon material-icons">open_in_new</i>
                    </a>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import modal from './modal.vue';
import loaderImageURL from '../assets/images/loader.gif';

export default {
  name: 'DetailsView',

  components: {
    modal,
  },


  data() {
    return {
      loaderImage: loaderImageURL,
      error: false,
      imageLoadErrors: [],
      isModalVisible: false,
    };
  },

  created() {
    this.$bus.$on('modal-close-event', this.closeView);
  },

  beforeDestroy() {
    this.$bus.$off('modal-close-event');
  },

  computed: {
    ...mapState([
      'tilesArray', 'isDetailsViewVisible',
    ]),

    detailsViewState: {
      get() {
        return this.isDetailsViewVisible;
      },
      set(value) {
        // set store
        this.setDetailViewVisible(value);
      },
    },
  },

  watch: {
    isDetailsViewVisible(visible) {
      if (visible) {
        this.$nextTick(() => {
          setTimeout(() => {
            const container = document.getElementById('rg-details-body');
            container.scrollTop = 0;
          }, 500);
        });
      }
    },
  },

  methods: {
    ...mapActions([
      'setDetailViewVisible',
    ]),

    getImageUrl(tile) {
      this.$set(tile, 'imgLoadError', false);
      return tile.img;
    },

    onImageError(tile) {
      this.$set(tile, 'imgLoadError', true);

      // this.imgLoadErrors[key] = true;
      console.log('Image Load Error');
      // tile.img = 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif';
    },

    closeView() {
      this.setDetailViewVisible(false);
    },
  },

};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";
.rg-card {
  margin-bottom: 48px;
  flex: 1 1 auto;
}

div#rg-details-card {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

div#rg-details-body {
    flex: 0 1 calc(100vh - 64px); ;
    overflow-y: auto;
    padding: 0 8px;
}

.details-layout {
  flex-direction: row;

  @media only screen and (max-width : @xs) {
    flex-direction: column-reverse;
  }
}

.rg-divider {
  margin-top: 16px;
}

.rg-details-list-row {
  flex: 1 1 100%;
  min-height: 46px;
  display: flex;
}
.rg-field-name {
  flex: 1 1 35%;
  text-align: left;
  // white-space: nowrap;
}
.rg-field-value {
  flex: 1 1 65%;
  text-align: left;
}
</style>
<style>
.note ul {
  margin: 10px 30px;
}
</style>
